module.exports = __webpack_public_path__ + "static/img/vuetify.624068b.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/images/tecnologias/vuetify.png
// module id = fjUR
// module chunks = 1